import React, {useEffect, useState} from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/Overview.scss";
import 'chartjs-adapter-moment';
import 'moment';
import DatePicker from "../../components/DatePicker";
import ChartTemplate from "../../components/Overview/ChartTemplate";
import AccountsSection from "../../components/Overview/AccountsSection";
import MerchantSalesAPI from "../../api/MerchantSalesAPI";

function MerchantOverviewTemplate() {
    const {
        GetTotalSales,
        merchantSales,
        merchantSalesLoading,
        salesChart
    } = MerchantSalesAPI();

    const [dateRange, setDateRange] = useState([
        new Date(new Date().setMonth(new Date().getMonth() - 1)),
        new Date(),
    ]);

    useEffect(() => {
        if (dateRange) {
            const startDate = new Date(Date.UTC(dateRange[0].getUTCFullYear(), dateRange[0].getUTCMonth(), dateRange[0].getUTCDate()));
            const endDate = new Date(Date.UTC(dateRange[1].getUTCFullYear(), dateRange[1].getUTCMonth(), dateRange[1].getUTCDate()));
            const startDateString = startDate.toISOString().substring(0, 10);
            const endDateString = endDate.toISOString().substring(0, 10);

            GetTotalSales(startDateString, endDateString);
        }

    }, [dateRange]);


    const curBalDOL = (merchantSales !== null ? merchantSales[0].TotalSales : null);
    const curBalLBP = (merchantSales !== null ? merchantSales[1].TotalSales : null);
    const statBalDOL = (salesChart && salesChart[0]?.ChartsPoints);
    const statBalLBP = (salesChart && salesChart[1]?.ChartsPoints);



    return (
        <>
            <HeaderComponent title="Sales Overview"/>
            <div className="OverviewPage">
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-lg-10 col-md-12 col-sm-12 overViewMerTopSection">

                            <div className="DatePicker">
                                <DatePicker
                                    value={dateRange}
                                    onChange={setDateRange}
                                />
                            </div>

                        </div>
                    </div>

                    <div className="row gx-5">
                        <AccountsSection accountLoading={merchantSalesLoading} data={curBalDOL} EntityType="MERCHANTEMPLOYEE" currency={"$"}/>
                        <AccountsSection accountLoading={merchantSalesLoading} data={curBalLBP} EntityType="MERCHANTEMPLOYEE" currency={"LBP"}/>
                    </div>

                    <div className="row gx-5">
                        <ChartTemplate
                            chartLoading={merchantSalesLoading}
                            statBalDOL={statBalDOL}
                            statBalLBP={statBalLBP}
                            title="SALES"
                            dateRange={dateRange}
                        />
                    </div>
                </div>
            </div>

        </>
    );
}

export default MerchantOverviewTemplate;